import * as React from 'react';
import { withRouter } from 'react-router';
import { Col, Row } from 'reactstrap';
import './Breadcrumbs.css'

export interface IBreadcrumbsProps {
    items: Array<any>;
    redirect: (url?: string)=> void;
    history: any;
    match: any;
    location: any;
}

const Breadcrumbs: React.SFC<IBreadcrumbsProps> = (props) => {
    const backClick = ()=>{
        props.history.goBack();
    }
    const inc = () => props.redirect();
    return (<>
    <Row className="breadcrumb-container">
            <Col xs={{ size: 10, offset: 1 }}>
            <Row>
            <Col xs="8">
                <div className="breadcrumbs">
                    <a href="javascript:void()" onClick={inc}>
                        Home
                    </a> &gt;&nbsp;
                    {props.items.map((i, index) => {
                        const val= () => { {return (index !== props.items.length-1) && props.redirect(i.url) }};
                      
                        return <React.Fragment key={index} ><a href="javascript:void()" className={(index === props.items.length-1 ? "current-item" : "")} onClick={val}>
                            {i.caption}
                        </a> {index !== props.items.length-1 ? <>&gt;&nbsp;</> : null}</React.Fragment>
                    })}
                </div>
                
            </Col>
            <Col xs="4">
                <a className="back-button float-right" href="javascript:void(0)" onClick={backClick}>&lt; Back</a>
            </Col>
        </Row>
            </Col>
        </Row>
        
    </>);
}

export default withRouter(Breadcrumbs);


// WEBPACK FOOTER //
// ./src/components/breadcrumbs/Breadcrumbs.tsx